// ============================================
// PAGE - Loading (cargando sesión)
// ============================================

import { Spinner } from '@almacenes/ui';
import logo from '@/assets/logos/logo.svg';

export const LoadingPage = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center" style={{ backgroundColor: '#F3F4F9' }}>
      <div className="text-center">
        <img 
          src={logo} 
          alt="Almacenes Digitales" 
          className="h-12 mx-auto mb-8"
        />
        
        
        <h2 className="text-3xl font-bold mb-4" style={{ color: '#11194F' }}>
          ¡Estamos iniciando tu sesión!
        </h2>
        
        <p className="text-gray-600 text-lg mb-8">
          Danos unos minutos para prepararlo todo. 🎉
        </p>
        
        <Spinner />
      </div>
    </div>
  );
};
